import { IndexRequest } from '@src/api/types/shared/request';

import { ApiResult } from '../../apiClient/apiResult';
import { axiosClient } from '../../apiClient/axiosClient';
import { Pagination } from '../../types/pagination';
import { SupportServiceTag } from '../../types/supportServiceTag';

type SupportServiceTagIndexResponse = {
  data: SupportServiceTag[];
  pagination: Pagination;
};

type SupportServiceTagCreateRequest = {
  name?: string;
  enabled?: boolean | number;
};
type SupportServiceTagCreateResponse = SupportServiceTag;

export const supportServiceTagApiClient = {
  index: async (params: IndexRequest): Promise<ApiResult<SupportServiceTagIndexResponse>> => {
    return await axiosClient.get('/tenant/support-service-tags', { params });
  },
  suggest: async (): Promise<ApiResult<SupportServiceTag[]>> => {
    return await axiosClient.get('/tenant/support-service-tags/suggest');
  },
  create: async (
    params: SupportServiceTagCreateRequest,
  ): Promise<ApiResult<SupportServiceTagCreateResponse>> => {
    return await axiosClient.post('/tenant/support-service-tags', params);
  },
  update: async (
    id: number,
    params: SupportServiceTagCreateRequest,
  ): Promise<ApiResult<Partial<SupportServiceTagCreateResponse>>> => {
    return await axiosClient.put(`/tenant/support-service-tags/${id}`, params);
  },
};
